export function formatDate(v: Date | string) {
  const d = typeof v === 'string' ? new Date(v) : v;
  return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}